<script>
// Componente para apresentar as mensagens agrupadas com suas ações
import { GlobalBus } from '@services/bus'
import store from '@state/store'
import moment from 'moment'

/**
 * Acoes: [MODAL.MODAL_MY_WALLET, MODAL.MODAL_WALLET_ANALYSIS]
 */
export default {
  props: {
    // Objeto para mensagem
    message: {
      type: Object,
      default: () => {
        return {}
      },
      required: true,
    },
  },
  computed: {
    clientes() {
      return store.getters['user/allClients'] || []
    },
  },
  methods: {
    formatDate(d, mask = 'DD/MM/YYYY HH:mm') {
      if (d) {
        return moment(d, 'DD/MM/YYYY HH:mm:SS').format(mask)
      } else {
        return '-'
      }
    },
    getCliente() {
      return this.clientes.find((c) => {
        return c.id === this.message.body.id_cliente
      })
    },
    /**
     * @vuese
     * Executar a ação da mensagem (abrir modal referente)
     * @arg act Ação a ser executada
     */
    doAction(msg) {
      const c = this.getCliente()
      if (!c) {
        this.$showSnack({
          text: 'Sem acesso ao cliente',
          button: true,
        })
        return
      }
      console.warn('Abrindo dados do cliente: ', c)
      GlobalBus.$emit(msg.trigger_action, c, this.message.body)
    },
  },
}
</script>

<template>
  <!-- Verificar porque o mb-2 não aplicou -->
  <div class="d-flex mb-2" style="margin-bottom: 10px;">
    <v-spacer v-if="message.owner" />
    <v-card
      :class="message.owner ? 'chat-right' : 'chat-left'"
      style="max-width: calc(100% - 32px);"
    >
      <v-card-text>
        <!-- message.mensagem_tipo -->
        <p v-if="message.sender_name && !message.owner" class="m-0 text-dark">
          {{ message.sender_name }}
        </p>
        <p class="m-0">{{ message.mensagem }}</p>
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <small
                v-if="message.data_registro"
                class="text-secondary chat-time"
              >
                {{ formatDate(message.data_registro, 'HH:mm') }}
              </small>
            </div>
          </template>
          <small> {{ formatDate(message.data_registro) }} </small>
        </v-tooltip>
        <small v-if="!message.data_registro" class="text-secondary chat-time">
          <v-icon x-small>mdi-clock-outline</v-icon>
        </small>
      </v-card-text>
      <v-btn
        v-if="message.trigger_action"
        color="primary"
        text
        class="m-5 mt-0"
        @click="doAction(message)"
      >
        Ver mais
      </v-btn>
    </v-card>
    <v-spacer v-if="!message.owner" />
  </div>
</template>

<style scoped>
.chat-time {
  padding: 5px;
  right: 0;
  position: absolute;
  bottom: -6px;
}

.chat-right {
  position: relative;
  min-width: 125px;
  border-radius: 6px;
  float: right;
  right: 20px;
  background-color: var(--gray-3) !important;
}

.chat-right::before {
  content: ' ';
  position: absolute;
  visibility: visible;
  top: 0px;
  right: -10px;
  border: 10px solid transparent;
  border-top: 10px solid var(--gray-3);
}

.chat-right::after {
  content: ' ';
  position: absolute;
  visibility: visible;
  top: 0px;
  right: -8px;
  border: 10px solid transparent;
  border-top: 10px solid var(--gray-3);
  clear: both;
}

.chat-left {
  position: relative;
  text-align: left;
  min-width: 125px;
  border-radius: 6px;
  float: left;
  left: 20px;
}

.chat-left::before {
  content: ' ';
  position: absolute;
  visibility: visible;
  top: 0px;
  left: -10px;
  border: 10px solid transparent;
  border-top: 10px solid white;
}

.chat-left::after {
  content: ' ';
  position: absolute;
  visibility: visible;
  top: 0px;
  left: -8px;
  border: 10px solid transparent;
  border-top: 10px solid white;
  clear: both;
}
</style>
